define('SubView',['underscore','backbone'],function(_,Backbone){
    //
    // abstraction
    // centralise les mécanismes de sous-vue
    // pour l'instanciation et la destruction des vues et sous-vues
    //

    return {
        attachView:function(subview){
            // attach subview
            var view = this;
            if(!view.subviews) view.subviews = [];
            try {
                view.subviews.push(subview);
            } catch (err) {
            }
            return subview;
        },
        detachView:function(subview){
            // detach subview
            if(subview){
                subview.remove();
                var view = this;
                view.subviews = _.reject(view.subviews, function(view) { return subview === view; });
            }
        },
        removeSubViews:function(){
            // supprime toutes les sous-vues
            var view = this;
            _(view.subviews).each(function(subview){
                if(subview){
                    subview.remove();
                }
            });
            delete view.subviews;
        },
        attachViews:function(views){
            // ajoute un tableau de vues
            var view = this;
            _(views).each(function(subview){view.attachView(subview)})
        },
        remove:function(){
            var view = this;
            view.removeSubViews.apply(view);
            Backbone.View.prototype.remove.apply(view);
        },
        appendView:function(constructor,selector,options){
            // instancie un constructeur,
            // et l’ajoute en sous-vue
            var view = this;
            if(_(options).isUndefined()) options = {};
            //
            if(_(selector).isString()){
                options.el = view.$(selector).get(0);
            }else{
                options.el = selector;
            }
            var subview = new constructor(options);
            view.attachView(subview);
            return subview;

        }
    }
});
